<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 20:14:34
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-15 18:52:57
 * @Description: 审批的每个问题组件
 -->
<template>
  <div class="approve-question-item border-attribute">
    <!-- 问题  员工所答 -->
    <div class="question-employee-answer">
      <div class="question">
        <slot name="question-serial-number" />
        {{ itemData.title }} ({{ itemData.questionScore }}分)
      </div>
      <div class="employee-answer">
        员工答案：{{ itemData.employeeAnswer.content }}
      </div>
    </div>
    <!-- 标准答案 -->
    <div class="standard-answer">
      正确答案：{{ itemData.answer.content }}
    </div>
    <div class="handle">
      <div
        v-if="isApprove"
        class="perfect-score cursor"
        @click="perfectClick"
      >
        满分
      </div>
      <div
        v-if="isApprove"
        class="clear-score cursor"
        @click="clearClick"
      >
        清零
      </div>
      <div class="score-input">
        分数
        <!-- mk-inpur-number 存在初始值 的问题 使用el-input-number -->
        <el-input-number
          v-model="itemData.score"
          :min="0"
          :width="45"
          :controls="false"
          :max="itemData.questionScore"
          :disabled="!isApprove"
          @change="handleScore"
        />
        分
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {

  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 是否为查看
    isApprove: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    // 满分操作
    perfectClick () {
      this.itemData.score = this.itemData.questionScore
      this.handleScore()
    },
    // 清零操作
    clearClick () {
      this.itemData.score = 0
      this.handleScore()
    },
    // 提交父级计算分数
    handleScore () {
      this.$emit('handle-score')
    }
  }
}
</script>
<style lang='scss' scoped>
.approve-question-item {
  margin-bottom: 20px;
  word-break: break-all;
  line-height: 18px;
  font-size: 13px;

  .question-employee-answer {
    padding: 15px 20px 10px;

    .question {
      font-weight: 500;
      margin-bottom: 10px;
    }
  }

  .standard-answer {
    padding: 15px 20px;
    background-color: #fafafa;
    border-bottom: 1px solid #e8e8e8;
  }

  .handle {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 11px 20px;

    .score-input {
      display: flex;
      align-items: center;
    }

    .perfect-score,
    .clear-score {
      color: #009cff;
    }

    .clear-score {
      margin: 0 20px 0 15px;
    }

    // .score-input {
    //   text-align: center;
    //   width: 44px;
    //   height: 27px;
    //   border-radius: 4px;
    //   margin: 0 5px;
    //   border: 1px solid rgba(217, 217, 217, 1);
    // }
  }
}
</style>
